import { PageHeader } from "components";
import { Entry } from "contentful";
import { NextPage } from "next";
import { NewsletterSection, PressHeaderSection, PressList } from "sections";
import { IPressItemFields, IStaticNewsletterSectionFields } from "types";
import {
  fetchHeaderPress,
  getContentfulEntries,
} from "../utils/contentful-api";

const Press: NextPage<{
  headerPress: (IPressItemFields & { createdAt: string })[];
  press: (IPressItemFields & { createdAt: string })[];
  newsletter: IStaticNewsletterSectionFields[];
}> = ({ headerPress, press, newsletter }) => {
  return (
    <div>
      <PageHeader title="Press" />
      <PressHeaderSection featured={headerPress} />
      <PressList press={press} />
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};

export default Press;

export async function getStaticProps() {
  const headerPressRes = await fetchHeaderPress();
  const headerPress = headerPressRes.map((p: Entry<IPressItemFields>) => {
    return { ...p.fields, createdAt: p.sys.createdAt };
  });

  const press = await getContentfulEntries<IPressItemFields>("pressItem");

  const newsletter = await getContentfulEntries<IStaticNewsletterSectionFields>(
    "newsletterSection"
  );

  return {
    props: {
      headerPress,
      press,
      newsletter,
    },
    revalidate: 3600, // Revalidate every hour
  };
}
